import { Map, List } from "immutable";
import { SUPPLY_CHAIN_ACTIONS, CASE_DETAILS_ACTIONS } from "constants/actions";
import { STATE_STATUS } from "constants/state-status";
import {
    SupplyChainRecord,
    SupplyChainFinancialsRecord
} from "records/supply-chain-record";

const INITIAL_STATE = new Map({
    records: new Map({}),
    financials: new Map({})
});

const DEFAULT_DATA = new Map({
    data: null,
    status: STATE_STATUS.UNFETCHED
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case CASE_DETAILS_ACTIONS.FETCH_CASE_DETAILS:
        return state
            .setIn(["records", payload.caseId], DEFAULT_DATA)
            .setIn(["financials", payload.caseId], DEFAULT_DATA);
    case SUPPLY_CHAIN_ACTIONS.FETCH_CASE_SUPPLY_CHAIN_DETAILS:
        return state.setIn(
            ["records", payload.caseId],
            DEFAULT_DATA.set("status", STATE_STATUS.FETCHING).set(
                "data",
                new SupplyChainRecord()
            )
        );
    case SUPPLY_CHAIN_ACTIONS.FETCHED_CASE_SUPPLY_CHAIN_DETAILS:
        return state.setIn(
            ["records", payload.caseId],
            DEFAULT_DATA.set("status", STATE_STATUS.FETCHED).set(
                "data",
                new SupplyChainRecord(payload.data)
            )
        );
    case SUPPLY_CHAIN_ACTIONS.FAILED_FETCH_CASE_SUPPLY_CHAIN_DETAILS:
        return state.setIn(
            ["records", payload.caseId, "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case SUPPLY_CHAIN_ACTIONS.UPDATE_CASE_SUPPLY_CHAIN_DETAILS:
        return state.setIn(
            ["records", payload.caseId, "status"],
            STATE_STATUS.UPDATING
        );
    case SUPPLY_CHAIN_ACTIONS.UPDATED_CASE_SUPPLY_CHAIN_DETAILS:
        return state
            .setIn(
                ["records", payload.caseId, "status"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                ["records", payload.caseId, "data"],
                new SupplyChainRecord(payload.data)
            );

    case SUPPLY_CHAIN_ACTIONS.FAILED_UPDATE_CASE_SUPPLY_CHAIN_DETAILS:
        break;
        //Financial Data Reduction
    case SUPPLY_CHAIN_ACTIONS.FETCH_CASE_SUPPLY_CHAIN_FINANCIALS:
        return state.setIn(
            ["financials", payload.caseId],
            DEFAULT_DATA.set("status", STATE_STATUS.FETCHING)
        );
    case SUPPLY_CHAIN_ACTIONS.FETCHED_CASE_SUPPLY_CHAIN_FINANCIALS:
        return state.setIn(
            ["financials", payload.caseId],
            DEFAULT_DATA.set("status", STATE_STATUS.FETCHED).set(
                "data",
                new SupplyChainFinancialsRecord({
                    data: new List(payload.data)
                })
            )
        );
    case SUPPLY_CHAIN_ACTIONS.FAILED_FETCH_CASE_SUPPLY_CHAIN_FINANCIALS:
        return state.setIn(
            ["financials", payload.caseId, "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
